import { Component, EventEmitter, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { DeleteGenericService } from 'app/services/delete-generic.service';
import { GeneratePdfFosilService } from 'app/services/generate-pdf-fosil.service';
import { NotificationsService } from 'app/services/notifications.service';
import { EndpointDictionary } from 'app/utils/endpoints-dictionary';
import {
  CombosConfiguration,
  FunctionsService,
  HttpService,
  LocalStorageService,
  MenuBreadCrumb,
  MessageService,
  params,
  SessionService,
  TableColumns,
  TableConfiguration,
} from 'brainloper-ui';
import { Equipment } from 'app/models2/maintenance/equipment';
import { Provider } from 'app/models2/administration/provider';
import { FuelOrder } from 'app/models2/fuel/fuel-order';
import { SizePicture } from 'app/models2/commos/size-pircture';
import { GenericResponse } from 'app/models2/commos/generic-response';
import { BaseResponse } from 'app/models2/commos/base-response';
import { enumProviderType } from 'app/models2/commos/enum-provider-type';

@Component({
  selector: 'app-fuel-order-detail',
  templateUrl: './fuel-order-detail.component.html',
  styleUrls: ['./fuel-order-detail.component.scss'],
})
export class FuelOrderDetailComponent implements OnInit {

  public urlTablaEquipos: string = `${EndpointDictionary.Equipment.EQUIPMENT_TABLE}`;
  private urlGetDetalleEquipos: string = `${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`;
  public urlGetTablaActividades: string = `${EndpointDictionary.Activity.ACTIVITY_TABLE}`;
  private urlGetDetalleActividad: string = `${EndpointDictionary.Activity.CRUD_ACTIVITY_DATA}`;
  private urlComboUsuarios: string = `${EndpointDictionary.User.USER_COMBO}`;
  private urlPostFO: string = `${EndpointDictionary.HistoricalFuel.CRUD_HISTORICAL_FUEL_DATA}`;

  public companyId = this.storage.get<number>('companyId')
  public paramsProvider: params[] = [{ id: 'providerTypeId', value: enumProviderType.COMBUSTIBLE }];

  public formStepeOne: UntypedFormGroup;
  private userId: number = this.storage.get<number>('userId')
  public data: dataFO = this.session.getData('data');
  public sizePicture: SizePicture = {
    margin: '3px',
    visibility: 'hidde',
  };
  public imageSrc: string = '';
  public equipo: Equipment = {};
  public provider: Array<Provider> = [{
    id: -1,
    providerName: 'Otro',
  }];
  public movil: boolean;

  public buttonActive: boolean = false;
  public buttonEnd: boolean = false;
  public screen: boolean = true;
  public providerOther: boolean = false;

  public fuelType: Array<string> = ['Gasolina', 'Extra', 'Diésel', 'Urea', 'Diésel y Urea', 'Otro'];
  public actividad = {
    body: [],
    label: '',
  };
  private id_orden: number = 0;
  private size: number = 90;
  public formFO: UntypedFormGroup;

  // combo autorizada //
  public reloadComboauthorize = new EventEmitter<any>();
  public combosConfigauthorize: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlComboUsuarios,
    urlParams: [],
    label: 'Autoriza',
    selected: 0,
  };

  // combo solicita //
  public reloadComboManager = new EventEmitter<any>();
  public combosConfigManager: CombosConfiguration = {
    visibleField: 'name',
    selectionField: 'userId',
    urlCombo: this.urlComboUsuarios,
    urlParams: [],
    label: 'Encargado',
    selected: 0,
  };

  // combo terceros //
  public reloadProvider = new EventEmitter<any>();
  public combosProvider: CombosConfiguration = {
    visibleField: 'providerName',
    selectionField: 'id',
    label: 'Lugar',
    urlCombo: `${EndpointDictionary.Provider.PROVIDER_TYPE_COMBO}`,
    urlParams: this.paramsProvider
  };

  //tabla equipos
  public recargarTablaEquipos = new EventEmitter<any>();
  public dataEquipos: Equipment[] = [];
  public configurationEquipos: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id',
  };
  public columnasEquipos: TableColumns<Equipment>[] = [
    {
      ID: 'brand',
      label: 'Marca',
      type: 'text',
      style: {
        textAlign: 'center',
        movil: 'no-movil',
      },
    },
    {
      ID: 'code',
      label: 'Código',
      type: 'text',
      style: {
        textAlign: 'center',
      },
    },
  ];

  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Orden de Combustible",
      router: '/combustible/autoriza_comb',
    },
    {
      name: "Detalle",
      current: true
    }
  ]

  constructor(
    private http: HttpService,
    private session: SessionService,
    private message: MessageService,
    private functionEter: FunctionsService,
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    public dialog: MatDialog,
    public deleteItem: DeleteGenericService,
    public notificationService: NotificationsService,
    private generatePdf: GeneratePdfFosilService,
    private storage: LocalStorageService

  ) {
    (this.formStepeOne = this.formBuilder.group({
      equipmentId: '',
    })),
      (this.formFO = this.formBuilder.group({
        requests: '',
        date: '',
        fuelType: '',
        place: '',
        gallons: '0',
        totalPrice: '0',
        authorizes: '',
        billNumber: '',
        gallonPrice: '0',
        salesOrder: '',
        providerId: null,
        description: ''
      }));
  }

  ngOnInit(): void {
    this.message.openLoading('Cargando', 'Cargando información');
    this.movil = screen.width > 600 ? false : true;
    this.combosConfigauthorize.selected = this.userId;
    this.formFO.controls.authorizes.setValue(this.userId);
    this.reloadComboauthorize.emit('selected');

    this.picture();


    if (this.data.action == 'edit') {
      this.startFields();
    }
    if (screen.height > 830) {
      this.size = 70;
    }
    if (this.data.action == 'solicitud') {
      this.solicitud();
    }
    if (this.data.action == 'add') {
      this.message.closeLoading();
    }

  }

  solicitud() {
    this.equipo.code = this.data.body.code;
    this.equipo.brand = this.data.body.equipmentBrand;
    this.equipo.currentOdometer = this.data.body.currentOdometer;
    this.equipo.id = this.data.body.equipmentId;
    this.formFO.controls.date.setValue(
      `${this.data.body.date}T08:00:00.000Z`
    );

    this.formFO.controls.requests.setValue(this.data.body.requests)
    this.combosConfigManager.selected = this.data.body.requests
    this.reloadComboManager.emit('selected')
    this.actividad.label = 'Formulario';
    this.checkDateRange(this.data.body.date);
    this.message.closeLoading();
  }

  async startFields() {
    this.equipo.code = this.data.body[0].code;
    this.equipo.brand = this.data.body[0].equipmentBrand;

    for (let controls of Object.keys(this.formFO.controls)) {
      if (this.data.body[0][controls]) {
        this.formFO.controls[controls].setValue(
          this.data.body[0][controls]
        );
      }
    }

    if (this.data.body[0].providerId > 0) {
      this.combosProvider.selected = this.data.body[0].providerId;
    } else {
      this.combosProvider.selected = -1;
      this.ValueIDProvider({ id: -1 });
    }
    this.reloadProvider.emit('selected');

    let fecha = this.functionEter.dateIso(this.data.body[0].date);
    this.formFO.controls.date.setValue(`${fecha}T08:00:00.000Z`)
    this.message.closeLoading();
  }

  ValueIDProvider($event: Provider) {
    if ($event && $event.id > 0) {
      this.providerOther = false;
      this.formFO.controls.place.setValue($event.providerName)
    } else {
      this.providerOther = true;
      this.formFO.controls.place.setValue("");
    }
  }

  async clickFilaEquipos($event: Equipment) {
    let res: Equipment = await this.http.getDataBody(
      `${this.urlGetDetalleEquipos}/${$event.id}`
    );
    if (res) {
      this.equipo = res[0];
    }
    if (this.equipo.photo == '') {
      this.imageSrc = 'Falta Imagen';
    }
    this.formFO.controls.requests.setValue(this.equipo.userId)
    this.combosConfigManager.selected = this.equipo.userId
    this.reloadComboManager.emit('selected')
    this.imageSrc = `${EndpointDictionary.Base._BASE_URL_V2}${this.equipo.photo}/${this.companyId}`;
    this.sizePicture.visibility = 'visible';
    this.formStepeOne.controls.equipmentId.setValue(this.equipo.id);
  }

  async saveFO($event: SubmitEvent, form: FuelOrder) {
    const submitButton = $event.submitter as HTMLButtonElement;
    let print = submitButton.name == "F" ? false : true
    this.buttonActive = true;
    form.date = this.functionEter.dateForm(form.date)
    form.equipmentId = this.equipo.id
    form.active = 1
    form.authorized = 1

    if (this.data.action == 'add' || this.data.action == 'solicitud') {

      this.message.openLoading('Cargando', 'Creando Orden');


        let res: GenericResponse = await this.http.postDataBody(
          `${this.urlPostFO}`, form);

        if (res) {
          this.id_orden = res.insertId;
          let notificado: string = form.requests.toString();
          let descripcion: string = `Equipo:${this.equipo.code} / ${'Orden de Combustible'}`;

          if (this.id_orden > 0) {
            let res = await this.notificationService.sendNotificationFuelOrder(
              descripcion,
              this.id_orden,
              notificado
            );
            if (res) {
              if (this.data.action == 'solicitud') {
                await this.deleteNotificationAndEmergencyActivity(
                  `notificaciones/solicitudCombustible?id_actividad_emergente=${this.data.body.id}`,
                  this.data.body.id
                );

              }
              this.message.closeLoading();

              if (print) {
                let resprint = await this.generatePdf.printTemplateFO(this.id_orden, true)
                if (resprint) {
                  this.message.closeLoading();
                  this.message.SuccessToast(`Orden de combustible creada`)
                  setTimeout(() => {
                    this.router.navigate(["combustible/autoriza_comb"])
                  }, 500);
                }
              } else {
                this.message.SuccessToast('Orden de combustible creada');
                setTimeout(() => {
                  this.router.navigate(['combustible/autoriza_comb']);
                }, 500);
              }
            }
          }
        } else {
          this.message.Error('Error', `Error creando orden de combustible`);
          this.buttonActive = false;
          this.message.closeLoading();
        }
    } else {
      this.message.openLoading('Cargando', 'Actualizando orden de combustible');
      form.equipmentId = this.data.body[0].equipmentId;
      form.id = this.data.body[0].id;

        let res: GenericResponse = await this.http.putDataBody(
          `${this.urlPostFO}`,
          form
        );
        if (res) {
          this.message.closeLoading();
          this.message.SuccessToast(
            'Orden de combustible actualizada correactmente'
          );
          setTimeout(() => {
            this.router.navigate(['combustible/autoriza_comb']);
          }, 500);
        } else {
          this.buttonActive = true;
          this.message.closeLoading();
        }
    }
  }

  checkDateRange($event: string) {
    let mesH;
    let mesUser;
    let hoy = new Date();
    let date = new Date($event);
    let year = hoy.getFullYear() - date.getFullYear();
    let month = date.getMonth() - hoy.getMonth();
    let day = date.getDate() - hoy.getDate();
    // console.log('fecha', year, month, day);

    switch (hoy.getMonth()) {
      case 0:
        mesH = 'Enero';
        break;
      case 1:
        mesH = 'Febrero';
        break;
      case 2:
        mesH = 'Marzo';
        break;
      case 3:
        mesH = 'Abril';
        break;
      case 4:
        mesH = 'Mayo';
        break;
      case 5:
        mesH = 'Junio';
        break;
      case 6:
        mesH = 'Julio';
        break;
      case 7:
        mesH = 'Agosto';
        break;
      case 8:
        mesH = 'Septiembre';
        break;
      case 9:
        mesH = 'Octubre';
        break;
      case 10:
        mesH = 'Noviembre';
        break;
      case 11:
        mesH = 'Diciembre';
        break;
      default:
        break;
    }
    switch (date.getMonth()) {
      case 0:
        mesUser = 'Enero';
        break;
      case 1:
        mesUser = 'Febrero';
        break;
      case 2:
        mesUser = 'Marzo';
        break;
      case 3:
        mesUser = 'Abril';
        break;
      case 4:
        mesUser = 'Mayo';
        break;
      case 5:
        mesUser = 'Junio';
        break;
      case 6:
        mesUser = 'Julio';
        break;
      case 7:
        mesUser = 'Agosto';
        break;
      case 8:
        mesUser = 'Septiembre';
        break;
      case 9:
        mesUser = 'Octubre';
        break;
      case 10:
        mesUser = 'Noviembre';
        break;
      case 11:
        mesUser = 'Diciembre';
        break;
      default:
        break;
    }

    if (year != 0) {
      if (year == -1 && hoy.getMonth() == 11) {
        console.log(
          `Orden programada para el año ${date.getFullYear()}`
        );
      } else {
        this.message.Warning(
          'Advertencia',
          `Estamos en el año ${hoy.getFullYear()} y la fecha de esta orden está para el año ${date.getFullYear()}`
        );
      }
    } else {
      if (month > 0) {
        if (month == 1) {
          day = Math.abs(hoy.getDate() - date.getDate() - 30);
          if (day > 15) {
            this.message.Warning(
              'Advertencia',
              `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser}`
            );
          }
        } else {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser}`
          );
        }
      } else {
        if (month < 0) {
          this.message.Warning(
            'Advertencia',
            `Estamos en el mes ${mesH} y estás programando la orden para el mes ${mesUser} que ya pasó`
          );
        }
      }
    }
  }

  private async deleteNotificationAndEmergencyActivity(
    urlNotification: string,
    idEmergyActivity: number
  ) {
    let resDeleteActividadEmergente: BaseResponse<GenericResponse> =
      await this.http.deleteDataPromise(
        `${this.urlGetDetalleActividad}/${idEmergyActivity}`
      );
    if (resDeleteActividadEmergente['code'] === 0) {
      this.notificationService.deleteNotificationByUrl(urlNotification)
    } else {
      this.message.Error('Error', resDeleteActividadEmergente['message']);
    }
  }

  errorMessage() {
    this.message.Error('Error', 'Complete los campos');
  }

  picture() {
    let sizeW = ((screen.height + screen.width) / 2) * 0.3;
    let sizeH = ((screen.height + screen.width) / 2) * 0.2;
    this.sizePicture = {
      width: `${sizeW}px`,
      height: `${sizeH}px`,
    };
  }

  async print($event, data) {
    $event.preventDefault()
    let res: boolean | unknown = await this.generatePdf.printTemplateFO(this.data.body[0].id)

    if (res) {
      setTimeout(() => {
        this.router.navigate(['combustible/autoriza_comb'])
      }, 500);
    }

  }

  back($event) {
    $event.preventDefault();
    setTimeout(() => {
      this.router.navigate(['combustible/autoriza_comb']);
    }, 500);
  }

  async deleteFO($event) {
    $event.preventDefault();
    let arrayDelete: Array<FuelOrder> = [];
    arrayDelete.push(this.data.body[0]);
    let res = await this.deleteItem.deleteD(
      arrayDelete,
      this.urlPostFO,
      'id',
      'Orden de Trabajo'
    );
    if (res) {
      this.notificationService.deleteNotificationByUrl(`notificaciones/ordenCombustible?id_orden=${this.data.body[0].id}`)
      this.message.SuccessToast('Orden de combustible eliminada correctamente');
      this.router.navigate(['combustible/autoriza_comb']);
    }
  }
}

export interface dataFO {
  action: string;
  body: FuelOrder;
  responsable: string;
}
